module.exports = __webpack_public_path__ + "img/event-view-004.137126af.jpg";